import React, { useRef, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { TextField, Checkbox } from 'formik-material-ui';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ru';
import {
    DatePicker,
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MaskedInput from 'react-text-mask';
import {
    cadastrarMembro,
    atualizarMembro,
    getMembroById,
} from '../../services/GruposApi';
import {
    Card,
    CardContent,
    AppBar,
    Toolbar,
    Typography,
} from '@material-ui/core';
import InformationDialog from '../../components/InformationDialog';
import ImageCropDialog from '../../components/ImageCropDialog';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
            ]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

function DateMask(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

const useStyles = makeStyles(theme => ({
    foto: {
        width: 140,
        height: 200,
        objectFit: 'cover',
        display: 'block',
        margin: 'auto',
        backgroundColor: '#e0e0e0',
    },
    fotoPlaceholder: {
        width: 140,
        height: 200,
        margin: 'auto',
        backgroundColor: '#e0e0e0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    photoButton: {
        marginTop: theme.spacing(1),
        maxWidth: 200,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    button: {
        marginTop: 24,
        margin: theme.spacing(1),
    },
}));

export default function CadastrarMembro(props) {
    const phoneRegExp = /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/;
    const dateRgex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;

    const classes = useStyles();
    const history = useHistory();
    const inputEl = useRef(null);
    const [membro, setMembro] = useState(undefined);
    const [isFotoMudou, setIsFotoMudou] = useState(false);
    const { idGrupoPequeno, idIgreja, idMembro } = useParams();
    const [selectedImage, setSelectedImage] = useState('');
    const [informacao, setInformacao] = useState(false);
    const [cropDialogOpen, setCropDialogOpen] = useState(false);
    const [cropImageSrc, setCropImageSrc] = useState(null);

    function handleCancelar() {
        history.goBack();
    }

    function obterCultos() {
        let numCultos = 1;

        if (idIgreja === "1") {
            numCultos = 4;
        } else if (idIgreja === "2") {
            numCultos = 2;
        }

        let cultos = [];

        for (let i = 0; i < numCultos; i++) {
            cultos.push(i + 1);
        }

        return cultos;
    }

    async function fetchMembroById(idMembro) {
        try {
            const response = await (await getMembroById(idMembro)).data;
            response.txTelefoneCel = telefoneParser(response.txTelefoneCel);
            setMembro(response);
            setSelectedImage(response.txFotoUrl ? `${response.txFotoUrl}?t=${Date.now()}` : '');
        } catch (error) {
            console.error(error);
        }
    }

    function handleUpload(file) {
        const reader = new FileReader();
        reader.onloadend = function () {
            setCropImageSrc(reader.result);
            setCropDialogOpen(true);
        };
        reader.readAsDataURL(file);
    }

    function handleCropConfirm(croppedImage) {
        setSelectedImage(croppedImage);
        setIsFotoMudou(true);
        setCropDialogOpen(false);
        setCropImageSrc(null);
        inputEl.current.value = '';
    }

    function handleCropClose() {
        setCropDialogOpen(false);
        setCropImageSrc(null);
        inputEl.current.value = '';
    }

    const handleCadastrar = async (values, { setSubmitting }) => {
        if (!membro) {
            try {
                const membro = {
                    txMembro: values.txNome,
                    txTelefoneCel: values.txTelefone,
                    txEmail: values.txEmail,
                    txSexo: values.txSexo,
                    dtNascimento: values.dtNascimento,
                    nbCulto: values.nbCulto,
                    idGrupoPequeno: idGrupoPequeno,
                    txFoto: selectedImage.replace(
                        /^data:image\/[a-z]+;base64,/,
                        ''
                    ),
                    idIgreja: idIgreja,
                };
                console.log(membro);
                const response = await cadastrarMembro(membro);
                history.goBack();
            } catch (err) {
                setInformacao(true);
            }
        } else {
            try {
                const membroTemp = {
                    idMembro: membro.idMembro,
                    txMembro: values.txNome,
                    txTelefoneCel: values.txTelefone,
                    txEmail: values.txEmail,
                    txSexo: values.txSexo,
                    dtNascimento: values.dtNascimento,
                    nbCulto: values.nbCulto,
                    idGrupoPequeno: membro.idGrupoPequeno,
                    txFoto: isFotoMudou
                        ? selectedImage.replace(
                            /^data:image\/[a-z]+;base64,/,
                            ''
                        )
                        : '',
                    idIgreja: idIgreja,
                };
                const response = await atualizarMembro(idMembro, membroTemp);
                history.goBack();
            } catch (err) {
                if (err.response.status === 500) {
                    setInformacao(true);
                }
            }
        }

        setSubmitting(false);
    };

    useEffect(() => {
        if (!!idMembro && !membro) {
            fetchMembroById(idMembro);
        }
    }, [idMembro]);

    const telefoneParser = txTelefone => {
        if (!!txTelefone) {
            const telefone = txTelefone
                .normalize('NFD')
                .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
            if (telefone.length !== 9 && telefone.length !== 11) {
                return '';
            } else {
                if (telefone.length === 9) {
                    return '(92) ' + txTelefone;
                } else {
                    return txTelefone;
                }
            }
        }
        return '';
    };

    const handleClose = () => {
        setInformacao(false);
    };

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <Typography color="secondary" variant="h5">
                        {!membro ? 'Criar Membro' : 'Atualizar Membro'}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Card>
                <CardContent>
                    <Formik
                        enableReinitialize
                        initialValues={
                            !membro
                                ? {
                                    txNome: '',
                                    txEmail: '',
                                    txTelefone: '',
                                    txSexo: 'M',
                                    dtNascimento: undefined,
                                    nbCulto: '',
                                }
                                : {
                                    txNome: membro.txMembro,
                                    txEmail: membro.txEmail,
                                    txTelefone: membro.txTelefoneCel,
                                    txSexo: membro.txSexo,
                                    dtNascimento: membro.dtNascimento,
                                    nbCulto: membro.nbCulto || '',
                                }
                        }
                        onSubmit={(values, { setSubmitting }) => {
                            handleCadastrar(values, { setSubmitting });
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={Yup.object().shape({
                            dtNascimento: Yup.string()
                                .matches(dateRgex, 'Data Inválida')
                                .nullable('Data Inválida')
                                .required('Data Inválida'),
                            txNome: Yup.string().required('Digite o Nome'),
                            txEmail: Yup.string()
                                .nullable()
                                .email('Email Invalído'),
                            txTelefone: Yup.string().matches(
                                phoneRegExp,
                                'Telefone invalido'
                            ),
                        })}
                    >
                        {props => {
                            const {
                                touched,
                                errors,
                                isSubmitting,
                                submitForm,
                                values,
                                setFieldValue,
                            } = props;
                            return (
                                <form noValidate autoComplete="off">
                                    <Grid container spacing={3}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={'auto'}
                                            style={{ textAlign: 'center' }}
                                        >
                                            {selectedImage ? (
                                                <img
                                                    src={selectedImage}
                                                    alt="Foto"
                                                    className={classes.foto}
                                                />
                                            ) : (
                                                <div className={classes.fotoPlaceholder}>
                                                    <PersonOutlineIcon style={{ fontSize: 80, color: '#9e9e9e' }} />
                                                </div>
                                            )}
                                            <input
                                                ref={inputEl}
                                                type="file"
                                                onChange={e => {
                                                    handleUpload(
                                                        e.currentTarget
                                                            .files[0],
                                                        e
                                                    );
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                onClick={e => {
                                                    inputEl.current.click();
                                                }}
                                                color="primary"
                                                className={classes.photoButton}
                                            >
                                                Alterar Foto
                                            </Button>
                                        </Grid>
                                        <Grid item xs>
                                            <Field
                                                component={TextField}
                                                label="Nome"
                                                fullWidth
                                                inputProps={{
                                                    style: {
                                                        textTransform:
                                                            'uppercase',
                                                    },
                                                }}
                                                required
                                                name="txNome"
                                                className={classes.formControl}
                                                helperText={
                                                    errors.txNome &&
                                                    touched.txNome &&
                                                    errors.txNome
                                                }
                                                autoFocus
                                            />
                                            <Field
                                                component={TextField}
                                                label="Data de Nascimento"
                                                name="dtNascimento"
                                                required
                                                InputProps={{
                                                    inputComponent: DateMask,
                                                }}
                                                helperText={
                                                    errors.dtNascimento &&
                                                    touched.dtNascimento &&
                                                    errors.dtNascimento
                                                }
                                                className={classes.formControl}
                                            />

                                            <FormControl
                                                className={classes.formControl}
                                            >
                                                <InputLabel>Sexo</InputLabel>
                                                <Field
                                                    component={Select}
                                                    value={values.txSexo}
                                                    onChange={(e, value) => {
                                                        setFieldValue(
                                                            'txSexo',
                                                            value
                                                                ? value.props
                                                                    .value
                                                                : 'M'
                                                        );
                                                    }}
                                                    name="txSexo"
                                                >
                                                    <MenuItem value="M">
                                                        MASCULINO
                                                    </MenuItem>
                                                    <MenuItem value="F">
                                                        FEMININO
                                                    </MenuItem>
                                                </Field>
                                            </FormControl>
                                            <Field
                                                component={TextField}
                                                label="Telefone"
                                                name="txTelefone"
                                                InputProps={{
                                                    inputComponent: TextMaskCustom,
                                                }}
                                                helperText={
                                                    errors.txTelefone &&
                                                    touched.txTelefone &&
                                                    errors.txTelefone
                                                }
                                                className={classes.formControl}
                                            />
                                            <FormControl
                                                className={classes.formControl}
                                            >
                                                <InputLabel>Culto</InputLabel>
                                                <Field
                                                    component={Select}
                                                    name="nbCulto"
                                                    value={values.nbCulto}
                                                    onChange={(e, value) => {
                                                        setFieldValue(
                                                            'nbCulto',
                                                            value ? value.props.value : ''
                                                        );
                                                    }}
                                                    helperText={
                                                        errors.nbCulto &&
                                                        touched.nbCulto
                                                    }
                                                >
                                                    {obterCultos().map((culto) => <MenuItem value={culto}>
                                                        {culto}° CULTO
                                                    </MenuItem>)}
                                                </Field>
                                            </FormControl>
                                            <Field
                                                component={TextField}
                                                label="E-mail"
                                                name="txEmail"
                                                id="txEmail"
                                                fullWidth
                                                helperText={
                                                    errors.txEmail &&
                                                    touched.txEmail &&
                                                    errors.txEmail
                                                }
                                                className={classes.formControl}
                                            />
                                            <Button
                                                variant="contained"
                                                onClick={submitForm}
                                                color="primary"
                                                disabled={isSubmitting}
                                                className={classes.button}
                                            >
                                                Salvar
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleCancelar}
                                                disabled={isSubmitting}
                                                className={classes.button}
                                                type="button"
                                            >
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            );
                        }}
                    </Formik>
                </CardContent>
            </Card>
            <ImageCropDialog
                open={cropDialogOpen}
                imageSrc={cropImageSrc}
                onConfirm={handleCropConfirm}
                onClose={handleCropClose}
            />
            <InformationDialog
                titulo="Cadastrar Membro"
                handleClose={handleClose}
                open={informacao}
            >
                Já existe um membro cadastrado com os dados informados. Se você
                pesquisou e não localizou, verifique os dados informados na
                pesquisa e tente novamente. Se precisar de ajuda entre em
                contato via Whatsapp pelo número <b>99205-0094</b> ou envie um
                e-mail para <b>cadastro@nib.org.br</b>.
            </InformationDialog>
        </>
    );
}
